const sidepanel = {
	overlayVariants: {
		closed: {
			opacity: 0,
			transition: { delay: 0.5 },
		},
		opened: {
			opacity: 0.5,
		},
	},
	opacityVariants: {
		closed: {
			opacity: 0,
		},
		open: {
			opacity: 1,
			transition: { delay: 0.5 },
		},
	},
};
const horizontalAmount = 1000;

const cards = {
	opacityVariants: {
		initial: {
			opacity: 0,
		},
		animate: {
			opacity: 1,
		},
	},

	cardTransitionVariants: {
		enter: (direction) => {
			return {
				x: direction > 0 ? horizontalAmount : -1 * horizontalAmount,
			};
		},
		center: {
			x: 0,
			opacity: 1,
		},
		exit: (direction) => {
			return {
				x: direction < 0 ? horizontalAmount : -1 * horizontalAmount,
			};
		},
	},
};

const Animation = {
	sidepanel,
	cards,
};

export default Animation;
